import React from 'react';
import { useTransactionsList } from '../hooks/use-transactions-list.js';
import TransactionsPageView from './transactions-page-view.jsx';

function TransactionsPageContainer() {
  const state = useTransactionsList();
  return <TransactionsPageView {...state} />;
}

export default TransactionsPageContainer;
